import { render, staticRenderFns } from "./ShipManagement.vue?vue&type=template&id=a09f282a&scoped=true"
import script from "./ShipManagement.vue?vue&type=script&lang=ts"
export * from "./ShipManagement.vue?vue&type=script&lang=ts"
import style0 from "./ShipManagement.vue?vue&type=style&index=0&id=a09f282a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09f282a",
  null
  
)

export default component.exports